import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { ListingStatus } from '@steelbuy/ts-shared';

export interface MyPackagesContextValue {
    packageFilter: ListingStatus[];
    setPackageFilter: (filter: ListingStatus[]) => void;
}

const defaultValue: MyPackagesContextValue = {
    packageFilter: [],
    setPackageFilter: () => null,
};

const MyPackagesContext = createContext(defaultValue);

export const MyPackagesContextProvider = ({ children }: { children: ReactNode }) => {
    const [packageFilter, setPackageFilter] = useState<ListingStatus[]>([]);

    const value = useMemo(
        () => ({
            packageFilter,
            setPackageFilter,
        }),
        [packageFilter, setPackageFilter]
    );

    return <MyPackagesContext.Provider value={value}>{children}</MyPackagesContext.Provider>;
};

export const useMyPackagesContext = () => useContext(MyPackagesContext);
